import { useAppDispatch } from '@hooks/redux'
import { useEffect } from 'react'
import { setActiveSection } from '@redux/site/siteSlice'
import { Button, Checkbox, Flex, MultiSelect, Stack, Text } from '@mantine/core'

export const Notifications = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setActiveSection('Notifications'))
  })

  return (
    <Stack p="md">
      <Stack gap="xs">
        <Text fw="bold" size="sm" tt="uppercase" c="dimmed">
          Record Sharing
        </Text>
        <Checkbox
          size="md"
          label="Record shared in response to my invitation"
        />
      </Stack>
      <Stack gap="xs">
        <Text fw="bold" size="sm" tt="uppercase" c="dimmed">
          Record Linking
        </Text>
        <Checkbox
          size="md"
          label="Any record is linked to my record by others
"
        />
      </Stack>
      <Stack gap="xs">
        <Text fw="bold" size="sm" tt="uppercase" c="dimmed">
          Notes / Incidents
        </Text>
        <Checkbox
          size="md"
          label="Note or incident added to any record linked to my record"
        />
        <Checkbox size="md" label="Incident added to any record" />
      </Stack>
      <Stack gap="xs">
        <Text fw="bold" size="sm" tt="uppercase" c="dimmed">
          File Uploads
        </Text>
        <Checkbox
          size="md"
          label="File uploaded to any record linked to my record"
        />
      </Stack>
      <Stack gap="xs">
        <Text fw="bold" size="sm" tt="uppercase" c="dimmed">
          Tasks
        </Text>
        <Checkbox
          size="md"
          label="Task added to any record linked to my record"
        />
      </Stack>
      <Stack gap="xs">
        <Text fw="bold" size="sm" tt="uppercase" c="dimmed">
          Edit Access Requests
        </Text>
        <Checkbox
          size="md"
          label="A request to edit any record linked to my record is sent"
        />
        <Checkbox
          size="md"
          label="Staff edit the profile data of any record linked to my record"
        />
      </Stack>
      <Stack gap="xs">
        <Text fw="bold" size="sm" tt="uppercase" c="dimmed">
          Data Sharing Requests
        </Text>
        <Checkbox
          size="md"
          label="A data sharing request is sent to any record linked to my record"
        />
      </Stack>
      <Stack gap="xs">
        <Text fw="bold" size="sm" tt="uppercase" c="dimmed">
          Tags
        </Text>
        <Text>Notify me when:</Text>
        <Stack ml="md" gap="xs">
          <Checkbox size="md" label="any record" />
          <Checkbox size="md" label="any record linked to my record" />
          <Text>is tagged with</Text>
          <MultiSelect
            w={400}
            size="md"
            placeholder="Select or create one or more"
            data={[
              {
                label: 'Tag 1',
                value: 'tag1',
              },
              {
                label: 'Tag 2',
                value: 'tag2',
              },
            ]}
          />
        </Stack>
      </Stack>
      <Flex maw={580} mt="lg" justify="flex-start" gap="xs">
        <Button size="md" variant="default">
          Discard Changes
        </Button>
        <Button size="md">Save</Button>
      </Flex>
    </Stack>
  )
}
